<template>
  <button
    type="button"
    class="
      absolute
      top-4
      right-5
      lg:right-3
      2xl:right-5
      text-zinc-600
      transition-opacity
      hover:opacity-50
      focus:opacity-50
    "
    title="Clear"
    @click="$emit('click')"
  >
    <svg width="16" height="16">
      <path d="M3,3 L13,13 M3,13 L13,3" stroke="currentcolor" />
    </svg>
  </button>
</template>

<script>
export default {
  name: 'CloseButton',
}
</script>
